import { createContext } from 'react'

import { TiptapContextType } from './@types'

export const TiptapContext = createContext<TiptapContextType>({
  withProvider: false,
  isTouched: false,
  editor: null,
  state: null,
  toggleDialog: null,
  onFileUpload: null,
  onSlashMenuItemClick: null,
})
